import React from "react"
import PropTypes from "prop-types"
import MDBDataTable from "../../components/Common/MDBDataTable"
import { Row, Col, Card, CardBody } from "reactstrap"
import "./datatables.scss"

const WebsiteList = React.memo(({ websites }) => {

  return (
    <React.Fragment>
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>

              <MDBDataTable responsive bordered data={websites} entries={100} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
})

WebsiteList.propTypes = {
  websites: PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.object),
    rows: PropTypes.arrayOf(PropTypes.object),
  })
}

export default WebsiteList
